<template>
    <div class="container">
        <div class="page-content" style="max-height: 73vh;">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading text-dark">
                        <img src="/assets/dipocaco/pocas/boosters.png" alt="inventory-poca" class="page-poca">
                        {{ $t('boosters.title') }} <small v-if="$store.state.inventory.items.length > 0" class="muted bg-light text-dark px-1 page-heading-counter" style="color: dimgrey">{{ $store.state.inventory.items.length }}</small>
                    </h1>

                    <div v-if="$store.state.inventory.items.length >= 3" class="mb-3 row p-0 bulk-openers">
                        <div class="col-4 ps-0" v-if="(completedCollections >= bulkOpeningGoals.small && openMultiple === 0 && !cooldownIsActive(3)) || $store.state.user.isAdmin">
                            <a class="btn btn-sm bg-light text-dark w-100 text-center mb-1" v-on:click="bulkOpening(3)">⚡ 3</a>
                        </div>

                        <div class="col-4 ps-0" v-else>
                            <a class="btn btn-sm bg-dark text-light w-100 text-center btn-disabled mb-1" v-on:click="lockedBulkOpenerInfo(bulkOpeningGoals.small)">
                                <i class="fa fa-lock"></i> ⚡3<br/>
                            </a>
                        </div>

<!--                        <div class="col-4" v-else-if="cooldownIsActive(3)">-->
<!--                            <a class="btn btn-sm bg-dark text-light w-100 text-center btn-disabled mb-1" v-on:click="lockedBulkOpenerInfo(bulkOpeningGoals.small)">-->
<!--                                <i class="fa fa-lock"></i> ⚡3 COOLDOWN<br/>-->
<!--                            </a>-->
<!--                        </div>-->

                        <div class="col-4" v-if="completedCollections >= bulkOpeningGoals.mid && openMultiple === 0 && !cooldownIsActive(6)">
                            <a class="btn btn-sm bg-light text-dark w-100 text-center mb-1" v-on:click="bulkOpening(6)">⚡ 6</a>
                        </div>

                        <div class="col-4" v-else>
                            <a class="btn btn-sm bg-dark text-light w-100 text-center btn-disabled mb-1" v-on:click="lockedBulkOpenerInfo(bulkOpeningGoals.mid)">
                                <i class="fa fa-lock"></i> ⚡6<br/>
                            </a>
                        </div>

<!--                        <div class="col-4" v-else-if="cooldownIsActive(6)">-->
<!--                            <a class="btn btn-sm bg-dark text-light w-100 text-center btn-disabled mb-1" v-on:click="lockedBulkOpenerInfo(bulkOpeningGoals.mid)">-->
<!--                                <i class="fa fa-lock"></i> ⚡6 COOLDOWN<br/>-->
<!--                            </a>-->
<!--                        </div>-->

                        <div class="col-4 pe-0" v-if="completedCollections >= bulkOpeningGoals.large && openMultiple === 0 && !cooldownIsActive(12)">
                            <a class="btn btn-sm bg-light text-dark w-100 text-center mb-1" v-on:click="bulkOpening(12)">⚡ 12</a>
                        </div>

                        <div class="col-4 pe-0" v-else>
                            <a class="btn btn-sm bg-dark text-light w-100 text-center btn-disabled mb-1" v-on:click="lockedBulkOpenerInfo(bulkOpeningGoals.large)">
                                <i class="fa fa-lock"></i> ⚡12<br/>
                            </a>
                        </div>

<!--                        <div class="col-4" v-else-if="cooldownIsActive(12)">-->
<!--                            <a class="btn btn-sm bg-dark text-light w-100 text-center btn-disabled mb-1" v-on:click="lockedBulkOpenerInfo(bulkOpeningGoals.large)">-->
<!--                                <i class="fa fa-lock"></i> ⚡12 COOLDOWN<br/>-->
<!--                            </a>-->
<!--                        </div>-->
                    </div>

                    <div class="row inventory p-0">
                        <div v-if="$store.state.inventory.items.length > 0" v-for="inventoryItem in $store.state.inventory.items" class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-4 pb-2">
                            <div v-on:click="lastPulledBoosterCount = 1; inventoryItemToOpen = inventoryItem; skipSummary = false"
                                 v-on:contextmenu.prevent="lastPulledBoosterCount = 1; inventoryItemToOpen = inventoryItem; skipSummary = true"
                                 :class="'booster-display '+(inventoryItem.opening ? 'booster-display-animate' : '')"
                                 :style="'background-image: url(\''+inventoryItem.asset_url+'\')'"
                                 v-on:error="this.style.backgroundImage = 'url(\'/api/packshot/'+inventoryItem.set_id+'\')'"></div>
                        </div>

                        <div v-if="$store.state.inventory.items.length === 0" class="col-12 p-0">
                            <div class="alert alert-info mb-0">
                                {{ $t('boosters.empty') }}<br/>
                                {{ $t('boosters.buySome') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <booster-pull-display
            :inventoryItemToOpen="inventoryItemToOpen"
            :open-multiple="openMultiple"
            @boosterOpeningFinished="finishBoosterOpening"
            @cardsloaded="clearButtons()"/>

        <pulled-cards-modal
            :last-pulled-cards="lastPulledCards"
            :last-pulled-worth="lastPulledWorth"/>
    </div>
</template>

<script>
import BoosterPullDisplay from "../parts/BoosterPullDisplay.vue";
import CardService from "../../CardService";
import PulledCardsModal from "../parts/PulledCardsModal.vue";

export default {
    name: "Inventory",
    computed: {
        CardService() {
            return CardService
        }
    },
    components: {PulledCardsModal: PulledCardsModal, BoosterPullDisplay},
    data() {
        return {
            packOpening: false,
            inventoryItemToOpen: null,
            openMultiple: 0,
            lastPulledCards: null,
            lastPulledWorth: 0,
            lastPulledBoosterCount: 0,
            skipSummary: false,
            setBoosterCount: 2,
            completedCollections: 0,
            bulkOpeningGoals: {
                small: 10,
                mid: 30,
                large: 60
            }
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.$store.commit('updateUserInventory');
        this.fetchCompletedCollections();
    },
    methods: {
        clearButtons() {
            this.openMultiple = 0;
        },
        finishBoosterOpening(pulledCards) {
            if (this.skipSummary) {
                this.lastPulledCards = [];
                this.inventoryItemToOpen = null;
                return true;
            }

            this.inventoryItemToOpen = null;
            this.lastPulledCards = [];

            this.lastPulledCards = pulledCards.map((card) => {
                let jsonCard = JSON.parse(card.json);
                jsonCard.is_in_set_collection = card.is_in_set_collection
                return jsonCard;
            }).reverse();

            this.lastPulledWorth = this.lastPulledCards.map(card => CardService.getPrice(card)).reduce((partialSum, a) => partialSum + a, 0);

            setTimeout(() => {
                $("#opening-finished-modal").modal('toggle');
            }, 300)
        },
        fetchCompletedCollections() {
            axios.get('/api/collections/completed').then(res => {
                this.completedCollections = res.data;
            });
        },
        lockedBulkOpenerInfo(count) {
            if (this.completedCollections < count) {
                iziToast.info({
                    title: this.$i18n.t('boosters.bulkInfo', {count: count, have: this.completedCollections}),
                    timeout: 5_000
                })
            } else {
                iziToast.warning({
                    title: this.$i18n.t('boosters.currentlyOpening'),
                    timeout: 5_000
                });
            }
        },
        bulkOpening(count) {
            this.openMultiple = count;
            localStorage.setItem('bulk'+count, moment());
        },
        cooldownIsActive(count) {
            return false;
            if (!localStorage.getItem('bulk'+count)) {
                return false;
            }

            let lastTimestamp = moment(localStorage.getItem('bulk'+count));
            if (moment().add(5, 'minute').diff(lastTimestamp)) {
                return true;
            }

            return false;
        }
    },
};
</script>


<style scoped lang="scss">
.page-heading {
    background-image: url("/assets/dipocaco/pocas/inventory-poca.jpg");
    background-position: center 33%;
}

.inventory {
    max-height: 60vh;
    overflow-y: auto;

    .booster-display {
        height: 15em;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        transition: transform 0.5s ease;

        &:hover {
            cursor: pointer;
        }
    }
}

.currency-icon {
    height: 1.75em;
    margin-bottom: 0.2em;
}

.bulk-openers {
    small {
        font-size: 0.75em !important;
        white-space: nowrap;
    }
}
</style>
